// Folder name comparator that sorts month folders chronologically.
// Auto-generated month folders use hardcoded Romanian names (see
// backend/services/folder_automation.py), which sort wrong alphabetically
// (Februarie < Ianuarie < Iunie < Mai < Martie). English names are also
// recognized as a cheap safety net for manually created folders.
import { romanianMonths } from './dateUtils'

const englishMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

const monthNumberByName = new Map<string, number>()
romanianMonths.forEach((name, index) => monthNumberByName.set(name.toLowerCase(), index + 1))
englishMonths.forEach((name, index) => monthNumberByName.set(name.toLowerCase(), index + 1))

/**
 * Compare two folder names for sorting.
 * - If BOTH names are recognized month names (Romanian or English),
 *   compare by month number so months sort chronologically.
 * - Otherwise fall back to a locale-aware compare with numeric collation,
 *   so year folders like "2024"/"2025" also sort correctly.
 */
export function compareFolderNames(a: string, b: string): number {
  const monthA = monthNumberByName.get(a.trim().toLowerCase())
  const monthB = monthNumberByName.get(b.trim().toLowerCase())

  if (monthA !== undefined && monthB !== undefined) {
    return monthA - monthB
  }

  return a.localeCompare(b, 'ro', { numeric: true })
}
